module.exports = __webpack_public_path__ + "static/img/star.b3ed008c.png";